/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * BỎ DẤU TIẾNG VIỆT — một chỗ, cho mọi chỗ cần.
 *
 * 🔴 lee đặt hàng ô tìm tuyến *"không phân biệt dấu"*, và câu ấy nghe nhỏ hơn thực tế: người
 *   gõ tìm trên máy tính bảng ngoài hiện trường **không bỏ dấu vì lười, họ bỏ dấu vì bàn phím**.
 *   Một ô tìm bắt gõ đúng dấu là một ô tìm chỉ dùng được ở bàn giấy.
 *
 * ⛔ VÀ TÁCH RA KHỎI `csv.ts` VÌ HAI VIỆC KHÁC NHAU, dù chúng dùng chung một bước:
 *     `boDau`    -> KHOA TIM: giu nguyen khoang trang, giu chu hoa/thuong cho noi khac lo
 *     `tenTepCsv` -> SLUG: con phai nen khoang trang thanh `-`, bo ky tu la, ha chu thuong
 *   Gộp làm một hàm thì ô tìm gõ `"vo van"` sẽ so với `"vo-van-kiet"` — hai chuỗi không khớp
 *   nhau ở đúng chỗ người ta vừa gõ. Chung cái LÕI, khác cái ĐUÔI.
 *
 * ⚠ `đ`/`Đ` phải xử riêng: chúng KHÔNG phải chữ có dấu phụ, nên `NFD` không tách được — sau
 *   `normalize('NFD')` chúng vẫn là `đ`. Quên vế này thì `"Đống Đa"` không tìm được bằng `"dong"`,
 *   và đó đúng là kiểu tên quận người ta gõ nhiều nhất.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
export function boDau(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
}

/** Khoá so sánh cho ô tìm: bỏ dấu, hạ chữ thường, gom khoảng trắng. */
export const khoaTim = (s: string): string => boDau(s).toLowerCase().replace(/\s+/g, ' ').trim();
